<template>
    <span class="item-icons" v-if="icons.length > 0">
        <span class="item-icon" v-for="icon in icons" :key="icon.id" :title="icon.title">
            <i v-for="(iconClass, index) in icon.classes" :key="index" :class="iconClass"></i>
        </span>
    </span>
</template>

<script setup lang="ts">
    import { computed } from "vue";

    import { useArticleAttributesStore } from "@/data/stores/articleAttribute";

    import { splitIconClasses } from "@/shared/helpers/AttributeHelper";
    import { translateByLocationLanguage } from "@/shared/localization/language";

    const props = defineProps<{
        articleId: string;
        // set where the user picks from the offer, see iconAttributesForArticle
        includeOrderedBefore?: boolean;
        // set for an option: the top-level main item it is offered in
        mainArticleId?: string;
    }>();

    const iconAttributes = useArticleAttributesStore();

    const icons = computed(() =>
        iconAttributes
            .iconAttributesForArticle(props.articleId, props.includeOrderedBefore, props.mainArticleId)
            .map((a) => ({
                id: a.id,
                classes: splitIconClasses(a.iconClass),
                title: translateByLocationLanguage(a.name),
            }))
            .filter((a) => a.classes.length > 0)
    );
</script>
